import type { SupTransactionType, SupWeb3TxSingleVault } from "@/types";
import React, { useMemo } from "react";

import { SupText } from "@repo/core-ui";
import { useSimulationState } from "@/components/Web3/Common/Simulation/State";

interface Web3CommonSimulationSummaryProps {
  vaultList: SupWeb3TxSingleVault[];
  type?: SupTransactionType;
}
export default function Web3CommonSimulationSummary({ vaultList, type = "deposit" }: Web3CommonSimulationSummaryProps) {
  const { simulated, success, allDepositsPassed, allWithdrawalsPassed } = useSimulationState();

  const warning = useMemo(() => {
    const hasMultiStep = vaultList.some(vault => vault.recommend_vault_share_withdrawal);
    if (!simulated || success) {
      return undefined;
    }
    if (type === "deposit") {
      return allDepositsPassed
        ? hasMultiStep
          ? "SIMULATIONS INDICATE THAT WITHDRAWALS MAY NOT BE POSSIBLE FROM SOME OF THESE VAULTS. VAULTS COULD BE TEMPORARILY ILLIQUID OR BROKEN. PROCEED WITH CAUTION"
          : "Simulations indicate that some of your withdrawals may fail. This can happen because of time-locks, illiquidity, or vault issues. If you know this is an error, enabling retain vault shares in settings may solve this."
        : "SIMULATIONS INDICATE SOME OF YOUR DEPOSITS MAY FAIL";
    } else {
      if (!allWithdrawalsPassed) {
        return "SIMULATIONS INDICATE THAT SOME OF YOUR WITHDRAWALS MAY FAIL. POTENTIALLY DUE TO A TIMELOCK, ILLIQUIDITY, OR A VAULT ISSUE. If you know this is an error, enabling retain vault shares in settings may solve this.";
      }
    }
  }, [allDepositsPassed, allWithdrawalsPassed, simulated, success, type, vaultList]);

  return (
    warning && (
      <div className="bg-warning-50 px-4 py-2">
        <SupText variant="subtitle2" className="text-warning-900">
          {warning}
        </SupText>
      </div>
    )
  );
}
